import { type QueryClient, useQuery } from '@tanstack/react-query';
import type { ParsedInsightsFilters } from '@/common/api/types/dashboard/filters';
import { useOrgId } from '@/common/hooks/useOrgId';
import { ScopeSizeApi } from '@/features/insights-dashboard/api/scopeSize';
import { INSIGHTS_STALE_TIME } from '@/features/insights-dashboard/components/data/constants';
import { transformCompactToParsedFilters } from '@/features/insights-dashboard/hooks/transformInsightFilters';
import { insightsQueryKeys } from '@/features/insights-dashboard/queryKeys';

const DEFAULT_FILTERS = transformCompactToParsedFilters({});

export const invalidateScopeSize = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: insightsQueryKeys.scopeSize.all() });
};

export const useScopeSize = ({
  filters,
  scopeItemId,
  loopId,
  enabled = true,
}: {
  filters?: ParsedInsightsFilters;
  scopeItemId?: number;
  loopId: number;
  enabled?: boolean;
}) => {
  const orgId = useOrgId();
  const normalizedFilters = filters ?? DEFAULT_FILTERS;

  return useQuery({
    queryKey: insightsQueryKeys.scopeSize.byFilters({
      filters: normalizedFilters,
      scopeItemId,
      loopId,
      orgId,
    }),
    queryFn: () => ScopeSizeApi.getScopeSize({ filters: normalizedFilters, scopeItemId, loopId }),
    enabled,
    staleTime: INSIGHTS_STALE_TIME,
    placeholderData: (previousData) => previousData,
    retry: false,
  });
};
